import formFieldCommonOptions from 'foundation/js/formFieldCommonOptions'
import emailValidator from '../../foundation/js/inputValidators/emailValidator'

const options = formFieldCommonOptions('FormInputEmailField', {
    validatorFunction(input) {
        return emailValidator(input)
    }
})

export default options
